
































import Vue from "vue";
import Component from "vue-class-component";
import {
  QDrawer,
  QScrollArea,
  QList,
  QItem,
  QItemSection,
  QLayout,
  QHeader,
  QToolbar,
  QToolbarTitle,
  QPageContainer,
  QBtn,
  QPage
} from "quasar";

@Component({
  components: {
    QDrawer,
    QScrollArea,
    QList,
    QItem,
    QItemSection,
    QLayout,
    QHeader,
    QToolbar,
    QToolbarTitle,
    QPageContainer,
    QBtn,
    QPage
  }
})
export default class App extends Vue {
  drawer = false;

  toggleDrawer() {
    this.drawer = !this.drawer;
  }
}
